import React, { useEffect, useRef } from "react";

const CustomCursor = () => {
    const ballRef = useRef(null);
    const textRef = useRef(null);

    useEffect(() => {
        const ball = ballRef.current;
        const cursorText = textRef.current;
        const hoverAreas = document.querySelectorAll(".data_cursor");

        let mouseX = 0, mouseY = 0;
        let ballX = 0, ballY = 0;
        const speed = 0.1;

        const updateCursor = () => {
            ballX += (mouseX - ballX) * speed;
            ballY += (mouseY - ballY) * speed;

            if (ball) {
                ball.style.transform = `translate3d(${ballX}px, ${ballY}px, 0)`;
            }

            if (cursorText) {
                cursorText.style.transform = `translate3d(${ballX}px, ${ballY}px, 0)`;
            }

            requestAnimationFrame(updateCursor);
        };

        const handleMouseMove = (e) => {
            mouseX = e.clientX;
            mouseY = e.clientY;
        };

        const handleHoverEnter = (e) => {
            const text = e.target.getAttribute("data-cursor-text");

            if (text && cursorText) {
                cursorText.textContent = text;
                cursorText.style.opacity = "1";
            }

            if (ball) {
                ball.style.width = "90px";
                ball.style.height = "90px";
            }
        };

        const handleHoverLeave = () => {
            if (cursorText) cursorText.style.opacity = "0";
            if (ball) {
                ball.style.width = "12px";
                ball.style.height = "12px";
            }
        };

        document.addEventListener("mousemove", handleMouseMove);

        hoverAreas.forEach((el) => {
            el.addEventListener("mouseenter", handleHoverEnter);
            el.addEventListener("mouseleave", handleHoverLeave);
        });

        updateCursor();

        return () => {
            document.removeEventListener("mousemove", handleMouseMove);
            hoverAreas.forEach((el) => {
                el.removeEventListener("mouseenter", handleHoverEnter);
                el.removeEventListener("mouseleave", handleHoverLeave);
            });
        };
    }, []);

    return (
        <div className="cursor">
            <div className="hide">
                <div id="cursor-ball" ref={ballRef}></div>
            </div>
            <div id="cursor-text" ref={textRef}></div>
        </div>
    );
};

export default CustomCursor;
